import { render, staticRenderFns } from "./hot_path.vue?vue&type=template&id=07664d6a&scoped=true&"
import script from "./hot_path.vue?vue&type=script&lang=js&"
export * from "./hot_path.vue?vue&type=script&lang=js&"
import style0 from "./hot_path.vue?vue&type=style&index=0&id=07664d6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07664d6a",
  null
  
)

export default component.exports